module.exports = __webpack_public_path__ + "img/rectangleCopy19@2x.335dfebd.png";